import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "advertising" }

import { ref } from 'vue';
import AdvertisingRow from './AdvertisingRow.vue';
import { JuouProForm, JuouProFormItem, useBaseAsync } from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  __name: 'Advertising',
  props: {
    position: {}
  },
  setup(__props: any) {

const loading = ref(false);

const props = __props;

const addDialogRef = ref<InstanceType<typeof JuouProForm>>();

const rowOp: {
    value: any;
    label: string;
}[] = [
  {
    label: '轮播',
    value: 'carousel',
  },
  {
    label: '均匀分布',
    value: 'distribute',
  },
];

const items: JuouProFormItem[] = [
  {
    type: 'select',
    label: '类型',
    name: 'type',
    options: rowOp,
    rule: [{ required: true }],
  },
];

const advertisingRowDatas = ref<any[]>([]);

const init = useBaseAsync(async() => {
  try {
    loading.value = true;
    const res = await useApi().advertisingApi.listAdvertisingRowadvertising({
      conditions: {
        position: props.position,
      },
    });
    if (res?.data?.data) {
      advertisingRowDatas.value = res.data.data;
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
});

const handleAdd = useBaseAsync(async(data: any) => {
  try {
    await useApi().advertisingApi.addAdvertisingRowadvertising({
      advertisingRowAdminVo: {
        position: props.position,
        type: data.type,
        sequence: advertisingRowDatas.value.length + 1,
      },
    });
    ElMessage.success('添加成功');
    init();
  } catch (error) {
    console.log(error);
  }
});

init();



return (_ctx: any,_cache: any) => {
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(advertisingRowDatas.value, (advertisingRow, inx) => {
      return (_openBlock(), _createBlock(AdvertisingRow, {
        key: advertisingRow.id,
        "row-data": advertisingRow,
        "is-first": inx === 0,
        "is-last": inx === advertisingRowDatas.value.length - 1,
        onChange: _cache[0] || (_cache[0] = () => _unref(init)())
      }, null, 8, ["row-data", "is-first", "is-last"]))
    }), 128)),
    _createElementVNode("div", {
      class: "advertising-add",
      onClick: _cache[1] || (_cache[1] = () => addDialogRef.value?.showDialog())
    }, [
      _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [
          _createVNode(_component_Plus)
        ]),
        _: 1
      }),
      _createTextVNode(" 添加一行 ")
    ]),
    _createVNode(_unref(JuouProForm), {
      ref_key: "addDialogRef",
      ref: addDialogRef,
      "is-dialog": true,
      title: "添加一行",
      items: items,
      onOk: _unref(handleAdd)
    }, null, 8, ["onOk"])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})